import React, { FC } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { Overlay } from 'src/shared/components';
import { useTranslate } from 'src/shared/providers';

interface Props {
  loading: boolean;
  onBalanceCheck: () => void;
  onBalanceCancel?: () => void;
  disabled?: boolean;
  label?: string;
}

export const AccrualBalanceCheckButton: FC<Props> = ({ loading, onBalanceCheck, onBalanceCancel, disabled, label }) => {
  const { t } = useTranslate();
  return (
    <>
      <Stack spacing={2} alignItems="center">
        <LoadingButton
          id="check-balance-btn"
          loading={loading}
          disabled={disabled}
          size="small"
          variant="contained"
          color="secondary"
          onClick={onBalanceCheck}
        >
          {label ?? t('absences.checkBalance')}
        </LoadingButton>
      </Stack>

      {onBalanceCancel && loading && (
        <Overlay spacing={2}>
          <CircularProgress size={32} />
          <Typography variant="h5">{t('absences.checkingBalance')}</Typography>
          <Button color="secondary" onClick={onBalanceCancel}>
            {t('global.cancel')}
          </Button>
        </Overlay>
      )}
    </>
  );
};
